import { ControllerRenderProps, FieldError, FieldValues } from "react-hook-form";
import { FormControl, FormHelperText, TextField, styled } from "@mui/material";

import { TextFieldSchema } from "@/types/form-generator-schema-type";
import DirectionProvider from "@/Providers/DirectionProvider";

interface IProps {
    field: ControllerRenderProps<FieldValues, string>;
    label?: string;
    placeholder: string;
    className?: string;
    errorMessage: FieldError;
    props?: TextFieldSchema["props"];
}

const StyledTextField = styled(TextField)(() => ({
    "& .MuiFormLabel-asterisk": {
        color: "red",
        fontSize: "20px",
    },
}));

const FormTextarea = ({ field, label, placeholder, className, errorMessage, props = {} }: IProps) => {
    return (
        <FormControl fullWidth className={className} margin="normal" variant="outlined">
            <DirectionProvider dir={(props.dir as "rtl" | "ltr") || "ltr"}>
                <StyledTextField
                    multiline
                    rows={7}
                    {...field}
                    {...props}
                    fullWidth
                    label={label}
                    placeholder={placeholder}
                    variant="outlined"
                />
                {errorMessage?.message ? <FormHelperText error>{errorMessage?.message}</FormHelperText> : null}
            </DirectionProvider>
        </FormControl>
    );
};

export default FormTextarea;
